module.exports = __webpack_public_path__ + "static/media/4. Murmullo del silencio, Óleo y resina epóxica en tela, 140 x 180 cm, 2018 copy.c2e03a9a.png";